import { faSparkles } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/base-components/Button";
import "src/base-components/CopilotButton.css";

import { Tooltip } from "src/design-system/Tooltip";

// DO NOT copy this pattern. The data-copilot-border wrapper hack exists solely for CopilotButton's
// gradient border and must not spread across the codebase. If you need a custom-styled button,
// create a proper variant in the Button component instead.
export const CopilotButton: React.FC<{
  onClick: () => void;
  disabled: boolean;
  loading?: boolean;
  tooltipContent?: string;
  dataLoc?: string;
  children: React.ReactNode;
}> = ({
  disabled,
  onClick,
  loading = false,
  tooltipContent,
  dataLoc = "copilot-button",
  children,
}) => {
  const button = (
    <div data-copilot-border={loading ? "animated" : "static"}>
      <Button
        dataLoc={dataLoc}
        disabled={disabled}
        iconLeft={faSparkles}
        size="sm"
        variant="secondary"
        onClick={onClick}
      >
        <span className="whitespace-nowrap">{children}</span>
      </Button>
    </div>
  );

  if (tooltipContent) {
    return (
      <Tooltip title={tooltipContent} asChild>
        {button}
      </Tooltip>
    );
  }

  return button;
};
